import { Component } from '@theme/component';

/**
 * @typedef {Object} PdpReviewsCarouselRefs
 * @property {HTMLElement} track
 */

/**
 * @extends {Component<PdpReviewsCarouselRefs>}
 */
export class PdpReviewsCarousel extends Component {
  requiredRefs = ['track'];

  /**
   * @param {number} direction
   */
  #scroll(direction) {
    const { track } = this.refs;
    if (!track) return;

    const card = track.querySelector('.pdp-reviews__card');
    const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
    const distance = (card?.offsetWidth ?? 418) + gap;

    track.scrollBy({ left: direction * distance, behavior: 'smooth' });
  }

  scrollPrevious() {
    this.#scroll(-1);
  }

  scrollNext() {
    this.#scroll(1);
  }
}

if (!customElements.get('pdp-reviews-carousel')) {
  customElements.define('pdp-reviews-carousel', PdpReviewsCarousel);
}
